<template>
  <div>
    <h5 class="header-stripe">
      <span v-if="!showDialogFlag">{{ header }}</span>
      <div class="action" v-if="!isCancelled && !showDialogFlag">
        <Button type="secondary" size="mini" v-if="!showDialogFlag" @click="$emit('cancelAction')">{{ $t('INDENT_CANCEL') }}</Button>
        <Button
          type="primary"
          size="mini"
          v-if="!showDialogFlag && this.statusCheck !== 7 && isVahanSarathiEnabled && !isVahanSarathiValidated"
          @click="vahanSarathiValidation">
            {{$t('INDENT_VALIDATE')}}
        </Button>
        <Button type="primary" size="mini" v-if="!showDialogFlag && this.statusCheck !== 7 && isVahanSarathiValidated" @click="isDetailsExist">{{$t('INDENT_SUBMIT')}}</Button>
      </div>
    </h5>
    <div class="py-15">
      <Form :inline="true" :disabled="isCancelled" class="form-default form-triple">
        <div class="form-item-group">
          <FormItem v-if="hasNonIndiaTimeZone" required
            :label="$t('INDENT_VEHICLE_NUMBER')">
            <Input
              :placeholder="$t('INDENT_ENTER_VEHICLE_NUMBER')"
              @input="setType('type0')"
              v-model="type0Number"/>
          </FormItem>
           <FormItem
            v-else-if="hasOverrideTypeWithVehicleConfig"
            :label="$t('INDENT_VEHICLE_NUMBER')"
            required :disabled="isCancelled || isDelivered">
            <Select
              filterable
              remote
              v-model="vehicleNumberId"
              class="select-default"
              value-key="id"
              placeholder="Select"
              @change="setVehicleValues($event)">
              <Option
                  v-for="item in vehicleNumberDropdownValues"
                  :key="item.id"
                  :label="item.number"
                  :value="item.id">
              <span style="float: left">{{ item.number }}</span>
              </Option>
            </Select>
          </FormItem>
          <template v-else>
            <FormItem required>
              <span slot="label">
                <Radio v-model.trim.lazy="vehicleNumberType" value="type1" :label="$t('INDENT_TYPE1')" :disabled="isDisabled">
                  {{$t('INDENT_VEHICLE_NUMBER')}}
                </Radio>
              </span>
              <ul class="list-inline-fields">
                <li class="digit-2">
                  <Input placeholder="XX" class="list-input" :disabled="isDisabled || isVehicleFieldDisabled" @change="setType('type1')"
                    v-model.trim.lazy="type1State"/>
                </li>
                <li class="digit-2">
                  <Input placeholder="X0" class="list-input" :disabled="isDisabled || isVehicleFieldDisabled" @change="setType('type1')"
                    v-model.trim.lazy="type1District"/>
                </li>
                <li>
                  <Input placeholder="XX00" class="list-input" :disabled="isDisabled || isVehicleFieldDisabled" @change="setType('type1')"
                    v-model.trim.lazy="type1primNumber"/>
                </li>
                <li>
                  <Input placeholder="0000" class="list-input" :disabled="isDisabled || isVehicleFieldDisabled" @change="setType('type1')"
                    v-model.trim.lazy="type1secNumber" @input="debouncedSearchVehicle()"/>
                </li>
              </ul>
            </FormItem>
            <FormItem>
              <span slot="label">
                <Radio v-model.trim.lazy="vehicleNumberType" value="type2" :label="$t('INDENT_TYPE2')" :disabled="isDisabled">
                  {{$t('INDENT_VEHICLE_NUMBER')}}
                </Radio>
              </span>
              <ul class="list-inline-fields">
                <li>
                  <Input placeholder="XX00" class="list-input" :disabled="isDisabled || isVehicleFieldDisabled" @change="setType('type2')"
                    v-model.trim.lazy="type2PrimNumber"/>
                </li>
                <li>
                  <Input placeholder="0000" class="list-input" :disabled="isDisabled || isVehicleFieldDisabled" @change="setType('type2')"
                    v-model.trim.lazy="type2SecNumber" @input="debouncedSearchVehicle()"/>
                </li>
              </ul>
            </FormItem>
          </template>
          <FormItem v-if="hasOverrideTypeWithVehicleConfig && isDedicatedVehicleNumberFeatureEnabled
            && !isDedicatedIndent">
            <span slot="label">
              <Radio v-model.trim.lazy="vehicleNumberType" value="type1" :label="$t('INDENT_TYPE1')" :disabled="isDisabled">
                {{$t('INDENT_VEHICLE_NUMBER')}}
              </Radio>
            </span>
            <ul class="list-inline-fields">
              <li class="digit-2">
                <Input placeholder="XX" class="list-input" :disabled="isDisabled || isVehicleFieldDisabled" @change="setType('type1')"
                  v-model.trim.lazy="type1State"/>
              </li>
              <li class="digit-2">
                <Input placeholder="X0" class="list-input" :disabled="isDisabled || isVehicleFieldDisabled" @change="setType('type1')"
                  v-model.trim.lazy="type1District"/>
              </li>
              <li>
                <Input placeholder="XX00" class="list-input" :disabled="isDisabled || isVehicleFieldDisabled" @change="setType('type1')"
                  v-model.trim.lazy="type1primNumber"/>
              </li>
              <li>
                <Input placeholder="0000" class="list-input" :disabled="isDisabled || isVehicleFieldDisabled" @change="setType('type1')"
                  v-model.trim.lazy="type1secNumber" @input="debouncedSearchVehicle()"/>
              </li>
            </ul>
          </FormItem>
          <FormItem v-if="hasOverrideTypeWithVehicleConfig && isDedicatedVehicleNumberFeatureEnabled
            && !isDedicatedIndent">
            <span slot="label">
              <Radio v-model.trim.lazy="vehicleNumberType" value="type2" :label="$t('INDENT_TYPE2')" :disabled="isDisabled">
                {{$t('INDENT_VEHICLE_NUMBER')}}
              </Radio>
            </span>
            <ul class="list-inline-fields">
              <li>
                <Input placeholder="XX00" class="list-input" :disabled="isDisabled || isVehicleFieldDisabled" @change="setType('type2')"
                  v-model.trim.lazy="type2PrimNumber"/>
              </li>
              <li>
                <Input placeholder="0000" class="list-input" :disabled="isDisabled || isVehicleFieldDisabled" @change="setType('type2')"
                  v-model.trim.lazy="type2SecNumber" @input="debouncedSearchVehicle()"/>
              </li>
            </ul>
          </FormItem>
          <FormItem :label="$t('INDENT_INSURANCE_VALID_TILL')">
            <DatePicker
              v-model="insuranceDate"
              type="date"
              :placeholder="$t('INDENT_PICK_A_DATE')"
              size="small"/>
          </FormItem>
          <FormItem :label="$t('INDENT_CHASSIS_NUMBER')">
            <Input placeholder="900132CTZOXXXX" v-model="chasisNumber" />
          </FormItem>
          <FormItem :label="$t('INDENT_ENGINE_NUMBER')">
            <Input placeholder="CTZP12345XXXX" v-model="engineNumber"/>
          </FormItem>
          <FormItem :label="$t('INDENT_FITNESS_CERTIFICATE')">
            <DatePicker
              v-model="fitnessDate"
              type="date"
              :placeholder="$t('INDENT_PICK_A_DATE')"
              size="small"/>
          </FormItem>
        </div>
        <div class="form-item-group mb-0">
          <FormItem
            :label="$t('INDENT_DRIVER_MOBILE_NUMBER')"
            v-if="hasOverrideTypeWithVehicleConfig"
            required :disabled="isCancelled || isDelivered">
            <Select
              filterable
              remote
              clearable
              :filter-method="queryfire"
              v-model="driverNumberId"
              class="select-default"
              value-key="id"
              placeholder="Select"
              @change="setDriverValues($event)">
             <Option
                  v-for="item in phoneNumberDropdownValues"
                  :key="item.driver_id"
                  :label="`${item.mobile_number} - ${item.driver_name || ''}`"
                  :value="item.driver_id">
                <span style="float: left">{{ item.mobile_number }} - {{ item.driver_name || ''}}</span>
              </Option>
            </Select>
          </FormItem>
          <FormItem  v-if="!hasOverrideTypeWithVehicleConfig
              || (hasOverrideTypeWithVehicleConfig && isDedicatedVehicleNumberFeatureEnabled && !isDedicatedIndent)"
            :label="$t('INDENT_DRIVER_MOBILE_NUMBER')" required :disabled="isDelivered">
            <Input :placeholder="$t('INDENT_DRIVER_MOBILE_NUMBER_SAMPLE')" type="number"
              v-model.trim.lazy="driverPhNumber" />
          </FormItem>
          <FormItem :label="$t('INDENT_DRIVER_NAME')" :disabled="isDelivered"
            v-if="!hasOverrideTypeWithVehicleConfig
              || (hasOverrideTypeWithVehicleConfig && isDedicatedVehicleNumberFeatureEnabled && !isDedicatedIndent)">
            <Input placeholder="Enter Driver Name" v-model="driverName"/>
          </FormItem>
          <FormItem :label="$t('INDENT_LICENSE_NUMBER')" :required="isSarathiValidationEnabled" :disabled="isDelivered">
            <Input placeholder="311121/1212/1" v-model="driverLicense"/>
          </FormItem>
        </div>
        <div class="form-item-group">
          <div class="form-input-group">
            <FormItem :label="$t('INDENT_ESTIMATE_ARRIVAL')" >
              <DatePicker
                v-model="estimateArrivalTime"
                type="datetime"
                :placeholder="$t('INDENT_SELECT_DATE_AND_TIME')"
                :format="datePickerFormat"
                :picker-options="validToPickerOptions"
                size="small"/>
            </FormItem>
            <FormItem :label="$t('INDENT_REMARKS')" >
              <Input :placeholder="$t('INDENT_ENTER_REMARKS')" v-model="remarks" />
            </FormItem>
            <FormItem :label="$t('MDM_VEHICLE_BS_STANDARD')" :required="isBharatStageMandate">
              <Select
                filterable
                remote
                class="select-default no-bg"
                size="mini"
                placeholder="Select Bharat Stage"
                v-model.trim="bharatStage"
                :disabled="isDisabled || isVehicleFieldDisabled"
                  >
               <Option v-for="item in bharatStageOptions"
                :key="item.id" :label="item.label"
                :value="item.name" />
             </Select>
           </FormItem>
            <FormItem :label="$t('INDENT_DRIVER_DOB')" required v-if="isSarathiValidationEnabled" >
              <DatePicker
                v-model="driverDOB"
                type="date"
                :placeholder="$t('INDENT_PICK_A_DATE')"
                size="small"/>
            </FormItem>
            <FormItem :label="$t('INDENT_RC')" :required="isRCMandatory">
                <Input :placeholder="$t('INDENT_RC_SAMPLE')" v-model="rcNumber" :disabled="hasExistingRcNumber" />
            </FormItem>
            <FormItem :label="$t('INDENT_TARE_UNLADEN_WEIGHT')" :required="isRCMandatory">
                <Input :placeholder="$t('INDENT_ENTER_TARE_UNLADEN_WEIGHT')" v-model.number="tareUnladenWeight" :disabled="hasExistingWeights" type="number" />
            </FormItem>
            <FormItem :label="$t('INDENT_GROSS_VEHICLE_WEIGHT')" :required="isRCMandatory">
                <Input :placeholder="$t('INDENT_ENTER_GROSS_VEHICLE_WEIGHT')" v-model.number="grossVehicleWeight" :disabled="hasExistingWeights" type="number" />
            </FormItem>
          </div>
        </div>
        <div class="form-item-group" v-if="!hasOverrideTypeWithVehicleConfig">
            <FormItem :label="getVehicleDimensionsLabel('length')" :required="areVehicleDimensionsMandatory" v-if="$hasFeature('vehicle_dimensions_mandatory_for_new_truck') || $hasFeature('decouple_feature_for_vehicle_dimensions')">
              <Input :placeholder="$t('INDENT_ENTER_VEHICLE_LENGTH')" v-model="vehicleLength" @input="dimensionsEdited = true" type="number"/>
            </FormItem>
            <FormItem :label="getVehicleDimensionsLabel('width')" :required="areVehicleDimensionsMandatory" v-if="$hasFeature('vehicle_dimensions_mandatory_for_new_truck') || $hasFeature('decouple_feature_for_vehicle_dimensions')">
              <Input :placeholder="$t('INDENT_ENTER_VEHICLE_WIDTH')" v-model="vehicleWidth" @input="dimensionsEdited = true" type="number"/>
            </FormItem>
            <FormItem :label="getVehicleDimensionsLabel('height')" :required="areVehicleDimensionsMandatory" v-if="$hasFeature('vehicle_dimensions_mandatory_for_new_truck') || $hasFeature('decouple_feature_for_vehicle_dimensions')">
              <Input :placeholder="$t('INDENT_ENTER_VEHICLE_HEIGHT')" v-model="vehicleHeight" @input="dimensionsEdited = true" type="number" />
            </FormItem>
            <FormItem :label="$t('INDENT_VEHICLE_WEIGHT_CAPACITY(KG)')" :required="areVehicleDimensionsMandatory" v-if="$hasFeature('vehicle_dimensions_mandatory_for_new_truck')">
              <Input :placeholder="$t('INDENT_ENTER_VEHICLE_WEIGHT_CAPACITY')" v-model="vehicleWeightCapacity" type="number" />
            </FormItem>
            <FormItem :label="`${$t('VEHICLE VOLUME')} (${preferredVolumeUnit})`" >
              <Input :placeholder="`Enter ${$t('VEHICLE VOLUME')} (${preferredVolumeUnit})`" :value="computedVolume" disabled type="number"/>
            </FormItem>
          </div>
           <div class="form-input-group mt-10">
            <p class="text-xs text-bold mt-0">{{$t('INDENT_RC_ATTACHMENT')}}<span v-if="isRCAttachmentMandatory" style="color:#ed4014;"> *</span></p>
              <AttachmentsPopup
                :attachments="rcAttachmentsList"
                :maxAllowed="rcAttachmentLimit"
                :multiple="true"
                :allowDelete="true"
                :disableUpload="false"
                @addAttachments="addRcAttachment"
                @removeAttachments="removeRcAttachment"
              />
          </div>
      </Form>
    </div>
    <div class="popover-primary-footer pt-0" v-if="showDuplicateVehicleFlag">
      <div class="commentarea mt-5 commentborder p-20 text-left">
        <div class="mb-20">
        {{$t('INDENT_DUPLICATE_VEHICLE_ASSIGN', { indentNo: this.indentNo })}}
       </div>
        <div class="action action text-right">
          <Button type="secondary" size="mini" @click="showDuplicateVehicleFlag=false">
            {{$t('INDENT_EXIT')}}
          </Button>
        </div>
      </div>
    </div>
    <div class="popover-primary-footer pt-0" v-if="showAlertFlag">
      <div class="commentarea mt-5 commentborder p-20 text-left">
        <div class="mb-20">
        {{$t('INDENT_VEHICLE_CHECK_AT_ASSIGN', { vehicleNo: this.vehicleNo, indentNo: this.indentNo })}}
       </div>
        <div class="action action text-right">
          <Button type="secondary" size="mini" @click="showAlertFlag=false">
            exit
          </Button>
          <Button type="primary" size="mini" @click="activeTripCheck">
           Continue
          </Button>
        </div>
      </div>
    </div>
    <div v-if="showValidationFlags" class="popover-custom no-border with-shadow larger-dialog" placement="topright">
  <div class="popover-body bg-white w-750">
    <div class="dialog-header">
      <h4 class="dialog-title">{{$t(dynamicVerificationTitle)}}</h4>
    </div>
    <div class="status-section">
      <div v-for="(step, index) in steps" :key="index" :class="['status-box', step.status === 'failed' ? 'status-red' : '']">
        <span v-if="step.status === 'processing'" class="spinner"></span>
        {{ step.name }} - {{ capitalize(step.status) }}
      </div>
    </div>
  </div>
</div>
    <div class="popover-primary-footer pt-0" v-if="showDialogFlag">
      <div class="commentarea mt-5 commentborder p-20 text-left">
        <div class="mb-20">
           {{$t('INDENT_TRIP_EXIST_CHECK_AT_ASSIGN', { indentNo: this.indentNo })}}
          </div>
        <div class="action action text-right">
          <Button type="secondary" size="mini" @click="showDialogFlag=false">
            {{$t('NO')}}
          </Button>
          <Button type="primary" size="mini" @click="assign">
            {{$t('INDENT_YES_PROCEED')}}
          </Button>
        </div>
      </div>
    </div>
    <div
        class="popover-custom no-border with-shadow" placement="topright"
        v-if="showValidationFlag"
      >
        <div v-if="!showOverride" class="popover-body bg-white w-350">
          <div class="d-flex justify-content-between">
            <h3 class="mt-0">{{ $t('WARNING') }}
              <svgicon name="icon-error-info" width="12" height="12" :original="true" />
            </h3>
            <div @click="handleCancelOverride()">
              X
            </div>
          </div>
         <p class="lh-20">{{ $t(integrationMessage) }}</p>
          <div>
            <div class="status-warn status-red full-width">
              <ol class="m-0 py-5 px-20">
                <li v-for="(message, index) in invalidFieldsList" :key="index">
                  {{ message }}
                </li>
              </ol>
            </div>
          </div>
          <div class="popover-footer" v-if="isSarathiOverrideEnabled || skipValidation">
          <Button type="secondary" size="mini" @click="handleCancelOverride()">
            {{ $t('CANCEL') }}
          </Button>
          <Button type="primary" size="mini" @click="getOverrideReasons()">
            {{$t('OVERRIDE')}}
          </Button>
        </div>
        </div>
        <div v-if="!skipValidation && showOverride" class="popover-body bg-white fw-350">
        <div class="d-flex justify-content-between">
          <h3 class="mt-0">{{$t('OVERRIDE_WARNING')}}
          </h3>
          <div @click="showValidationFlag=false">
            X
          </div>
        </div>
        <p class="lh-20">{{ $t('OVERRIDE_REASON_SELECT') }}</p>
        <div>
          <Form class="form-default mr-5">
            <FormItem label="OVERRIDE REASON" :required="true">
              <Select placeholder="Select Reason" size="mini" class="select-default content_text"
                v-model="overrideReason.data" @change="overrideReason.custom =''">
                <Option v-for="item in overrideReasonList" :key="item.key" :value="item.value">
                  <Ellipsis :text="item.value" :length="50" />
                </Option>

              </Select>
            </FormItem>
            <div v-if="overrideReason.data === $t('OTHERS')">
              <FormItem :label="$t('OTHERS')" :required="true">
                <Input :placeholder="$t('INDENT_ENTER_REASON') + ' (Minimum 15 character required)'" :maxlength="150"
                  :minlength="15" :rows="2" type="textarea" class="form-control"
                  v-model="overrideReason.custom"></Input>
              </FormItem>
            </div>
          </Form>
        </div>
        <div class="popover-footer">
          <Button type="secondary" size="mini" @click="handleCancelOverride()">
            {{ $t('CANCEL') }}
          </Button>
          <Button type="primary" :class="{'is-disabled': isReasonValidLength || !hasValidOverrideReason}" size="mini"
            @click="submitOverrideReason()" :disabled="!hasValidOverrideReason">
            {{$t('INDENT_SUBMIT')}}
          </Button>
        </div>
        <div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
  alpha,
  alphaNum,
  helpers } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import debounce from 'debounce';
import { orderType, vahanSarathi, statusIdDictionary, deliveryTypes, vehicleDimensionUnits, VolumeUnits } from 'pando-constants';
import { overrideReasonOptions } from '@/constants/reason-settings';
import momentTimeZone from 'moment-timezone';
import { bharatStageOptions, DEFAULT_RC_DOCUMENTS_LIMIT } from '../../../../../../../frontend/common-v2/constants/mdm';
import convert from 'convert-units';
import AttachmentsPopup from '@common/components/AttachmentsPopup';

const nonIndiaVehicleNumberFormat = helpers.regex('string', /^[a-zA-Z0-9-\s]{7,9}$/);

export default {
  components: { AttachmentsPopup },
  props: {
    header: {
      type: String,
      default: 'Vehicle Details',
    },
    vehicle: {
      type: Object,
      default: () => {},
    },
    driver: {
      type: Object,
      default: () => {},
    },
    isDelivered: {
      type: Boolean,
      default: false,
    },
    isCancelled: {
      type: Boolean,
      default: false,
    },
    isIndented: {
      type: Boolean,
      default: false,
    },
    vehicleNumberList: {
      type: Array,
      default: () => [],
    },
    driverNumberList: {
      type: Array,
      default: () => [],
    },
    hasOverrideTypeWithVehicleConfig: {
      type: Boolean,
      default: false,
    },
    statusCheck: {
      type: Number,
    },
    currentOrder: {
      type: Object,
      default: () => {},
    },
    datePickerFormat: {
      type: String,
      default: 'dd-MM-yyyy hh:mm A',
    },
    inspectionDocs: {
      type: Array,
      default: () => [],
    },
    inspection: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      data: {},
      orderType,
      vehicleNumberType: 'type1',
      type0Number: '',
      type1State: null,
      type1District: null,
      type1primNumber: null,
      type1secNumber: null,
      type2PrimNumber: null,
      type2SecNumber: null,
      fitnessDate: null,
      insuranceDate: null,
      bharatStage: '',
      chasisNumber: null,
      remarks: null,
      engineNumber: null,
      driverPhNumber: null,
      driverLicense: null,
      driverName: null,
      showDialogFlag: false,
      showValidationFlag: false,
      driverDOB: null,
      invalidFields: [],
      isVahanSarathiValidated: false,
      showAlertFlag: false,
      showDuplicateVehicleFlag: false,
      indentNo: null,
      isActiveTrip: true,
      vehicleNumberId: null,
      vehicleNumberValue: null,
      vehicleLength: 0,
      vehicleWidth: 0,
      vehicleHeight: 0,
      vehicleVolume: 0,
      dimensionsEdited: false,
      vehicleWeightCapacity: 0,
      driverNumberId: null,
      vehicleNo: 'NA',
      estimateArrivalTime: null,
      steps: [],
      invalidFieldsList: [],
      localValidFields: [],
      validationMessage: '',
      intervalId: null,
      showValidationFlags: false,
      selectedInspectionDoc: [],
      transactionId: '',
      skipValidation: false,
      showOverride: false,
      overrideReasonList: [],
      bharatStageOptions,
      rcNumber: '',
      rcAttachmentsList: [],
      existingRc: '',
      tareUnladenWeight: '',
      grossVehicleWeight: '',
      existingTareWeight: '',
      existingGrossWeight: '',
      overrideReason: {
        custom: '',
        data: '',
      },
      vahanInvalidFields: [],
      sarathiInvalidFields: [],
      status: [],
      isProgress: false,
    };
  },
  created() {
    // eslint-disable-next-line no-underscore-dangle
    this.vehicleNumberId = this.vehicle && this.vehicle._id;
    this.vehicleNumberValue = this.vehicle && this.vehicle.number;
    const vehicleArr = this.vehicle && this.vehicle.number.split(' ');
    if (this.hasNonIndiaTimeZone) {
      this.type0Number = this.vehicleNumberValue && this.vehicleNumberValue.replace(/ +/g, '');
      this.vehicleNumberType = 'type0';
    }
    if (vehicleArr && !this.hasNonIndiaTimeZone) {
      if (vehicleArr.length > 2) {
        this.type1State = vehicleArr[0];
        this.type1District = vehicleArr[1];
        this.type1primNumber = vehicleArr[2];
        this.type1secNumber = vehicleArr[3];
        this.vehicleNumberType = 'type1';
      } else {
        this.type2PrimNumber = vehicleArr[0];
        this.type2SecNumber = vehicleArr[1];
        this.vehicleNumberType = 'type2';
      }
    }
    this.fitnessDate = this.vehicle && this.vehicle.fitness_validity;
    this.insuranceDate = this.vehicle && this.vehicle.insurance_validity;
    this.bharatStage = this.vehicle && this.vehicle.bharat_stage;
    this.chasisNumber = this.vehicle && this.vehicle.chasis_number;
    this.remarks = this.vehicle && this.vehicle.remarks;
    this.engineNumber = this.vehicle && this.vehicle.engine_number;
    this.estimateArrivalTime = this.vehicle && this.vehicle.estimated_arrival_date;
    this.rcNumber = this.vehicle && this.vehicle.rc_number;
    this.existingRc = (this.vehicle && this.vehicle.rc_number) || '';
    this.tareUnladenWeight = this.vehicle && this.vehicle.tare_unladen_weight;
    this.grossVehicleWeight = this.vehicle && this.vehicle.gross_vehicle_weight;
    this.existingTareWeight = (this.vehicle && this.vehicle.tare_unladen_weight) || '';
    this.existingGrossWeight = (this.vehicle && this.vehicle.gross_vehicle_weight) || '';
    this.rcAttachmentsList = ((this.vehicle && this.vehicle.rc_attachments) || []).map(doc => ({
      id: doc.id, name: doc.name, url: doc.url,
    }));


    // eslint-disable-next-line no-underscore-dangle
    this.driverNumberId = this.driver && this.driver._id;
    this.driverPhNumber = this.driver && this.driver.phoneno;
    this.driverName = this.driver && this.driver.name;
    this.driverLicense = this.driver && this.driver.license_no;
    this.driverDOB = this.driver && this.driver.dob;

    // vehicle Dimensions
    this.vehicleLength = this.vehicle && this.vehicle.vehicle_length;
    this.vehicleWidth = this.vehicle && this.vehicle.vehicle_width;
    this.vehicleHeight = this.vehicle && this.vehicle.vehicle_height;
    this.vehicleVolume = this.vehicle && this.vehicle.vehicle_volume;
    this.vehicleWeightCapacity = this.vehicle && this.vehicle.vehicle_weight_capacity;

    this.isVahanSarathiValidated = !this.isVahanSarathiEnabled;

    // debounced function for fetching BS details during vehicle name search
    this.debouncedSearchVehicle = debounce(this.searchVehicleByNumber, 300);
  },
  validations() {
    return {
      type0Number: { required, nonIndiaVehicleNumberFormat, minLength: minLength(7), maxLength: maxLength(9) },
      type0: ['type0Number'],
      type1State: { required, alpha, minLength: minLength(1) },
      type1District: { required, alphaNum, minLength: minLength(1) },
      type1primNumber: { required, alphaNum, minLength: minLength(1) },
      type1secNumber: { required, numeric, minLength: minLength(1) },
      type1: ['type1State', 'type1District', 'type1primNumber', 'type1secNumber'],
      type2PrimNumber: { required, alphaNum, minLength: minLength(1) },
      type2SecNumber: { required, numeric, minLength: minLength(1) },
      type2: ['type2PrimNumber', 'type2SecNumber'],
      driverPhNumber: { required, numeric, minLength: minLength(10), maxLength: maxLength(10) },
      rcNumber: this.isRCMandatory ? { required } : {},
      tareUnladenWeight: this.isRCMandatory ? { required, minValue: value => value > 0 } : {},
      grossVehicleWeight: this.isRCMandatory ? { required, minValue: value => value > 0 } : {},
      estimateArrivalTime: { minValue: value => (value ?
        new Date(value) > new Date(this.currentOrder.indent_date) :
        true) },
    };
  },
  computed: {
    ...mapGetters({
      currentClient: 'app/currentClient',
      configurations: 'app/currentClientConfig',
    }),
    vehicleDimensionsUOM() {
      return (this.configurations && this.configurations.vehicle_dimensions_uom) || 'cm';
    },
    preferredVolumeUnit() {
      return (this.configurations && this.configurations.preferred_volume_unit) || VolumeUnits.CFT;
    },
    isFTLOrder() {
      return (
        this.currentOrder.vehicle_type_data &&
        this.currentOrder.vehicle_type_data.vehicle_type === deliveryTypes.FTL
      );
    },
    areVehicleDimensionsMandatory() {
      return this.$hasFeature('vehicle_dimensions_mandatory_truck_assign') && this.isFTLOrder;
    },
    isRCMandatory() {
      return this.$hasFeature('mandatory_rc_number');
    },
    isRCAttachmentMandatory() {
      return this.$hasFeature('mandatory_rc_attachment');
    },
    rcAttachmentLimit() {
      return (this.clientConfiguration && this.clientConfiguration.attachmentsLimit
        && this.clientConfiguration.attachmentsLimit.rc_documents) || DEFAULT_RC_DOCUMENTS_LIMIT;
    },
    hasExistingRcAttachments() {
      return this.rcAttachmentsList && this.rcAttachmentsList.length > 0;
    },
    hasExistingRcNumber() {
      return !!(this.existingRc.length > 0);
    },
    hasExistingWeights() {
      return !!(
        (this.existingTareWeight && this.existingTareWeight > 0) ||
        (this.existingGrossWeight && this.existingGrossWeight > 0)
      );
    },
    hasNonIndiaTimeZone() {
      const timezone = momentTimeZone.tz.zonesForCountry('IN')[0];
      return timezone.toLowerCase() !== this.currentClient.timezone.toLowerCase();
    },
    isDisabled() {
      if (this.$hasFeature('restrict_transporter_vehicle_assignment')) {
        const statusList = [5, 17, 18];
        return statusList.includes(this.currentOrder.status);
      }
      return false;
    },
    isSarathiValidationEnabled() {
      const deliveryType = this.isFTLOrder ? 'FTL' : 'PTL';
      const hasNewFlags = this.$hasFeature('sarathi_validation_ftl') || this.$hasFeature('sarathi_validation_ptl');
      if (hasNewFlags) {
        return deliveryType === 'FTL' ? this.$hasFeature('sarathi_validation_ftl') : this.$hasFeature('sarathi_validation_ptl');
      }
      return this.$hasFeature('sarathi_validation');
    },
    isVahanValidationEnabled() {
      const deliveryType = this.isFTLOrder ? 'FTL' : 'PTL';
      const hasNewFlags = this.$hasFeature('vahan_validation_ftl') || this.$hasFeature('vahan_validation_ptl');
      if (hasNewFlags) {
        return deliveryType === 'FTL' ? this.$hasFeature('vahan_validation_ftl') : this.$hasFeature('vahan_validation_ptl');
      }
      return this.$hasFeature('vahan_validation');
    },
    isBharatStageMandate() {
      return this.$hasFeature('bharat_stage_mandate');
    },
    isVahanSarathiEnabled() {
      return this.isSarathiValidationEnabled || this.isVahanValidationEnabled;
    },
    isVehicleFieldDisabled(){
       const hasFeatureToDisableTruckNumber = this.$hasFeature('restrict_truck_number_update_after_dispatch');
       const hasPermissionToUpdateTruckNumber  = this.$hasPermission('update_truck_number_after_dispatch_transporter');
       const isAfterDispatchStatus = [statusIdDictionary.dispatched, statusIdDictionary.delivery_pending, statusIdDictionary.delivered].includes(this.currentOrder.status);
       return isAfterDispatchStatus && hasFeatureToDisableTruckNumber && !hasPermissionToUpdateTruckNumber
    },
    phoneNumberDropdownValues() {
      if (this.driverNumberId) {
        const driverIndex = this.driverNumberList.findIndex(
          val => val.driver_id === this.driverNumberId);
        if (driverIndex === -1) {
          const newArray = [...this.driverNumberList];
          const driverObj = {
            driver_name: this.driver.name,
            // eslint-disable-next-line no-underscore-dangle
            id: this.driver._id,
            license_number: this.driver.license_no,
            mobile_number: this.driver.phoneno,
          };
          newArray.unshift(driverObj);
          return newArray;
        }
      }
      return this.driverNumberList;
    },
    vehicleNumberDropdownValues() {
      if (this.vehicleNumberId) {
        const vehicleIndex = this.vehicleNumberList.findIndex(
          val => val.id === this.vehicleNumberId);
        if (vehicleIndex === -1) {
          const newArray = [...this.vehicleNumberList];
          const vehicleObj = Object.assign({
            // eslint-disable-next-line no-underscore-dangle
            id: this.vehicle._id,
          }, this.vehicle);
          newArray.unshift(vehicleObj);
          return newArray;
        }
      }
      return this.vehicleNumberList;
    },
    validToPickerOptions() {
      const validFrom = new Date(this.currentOrder.indent_date);
      return {
        disabledDate(time) {
          return (
            time <= new Date(validFrom.getTime() - 86400000)
          );
        },
      };
    },
    getInspectionData() {
      const selectedInspection = [];
      const selectedInspectionDoc = this.selectedInspectionDoc;
      /* eslint-disable */
      const selectedInspectionData = this.inspection.reduce((result, ins) => {
        const key = ins.name;
        if (selectedInspection.indexOf(key) !== -1) {
          result[key] = true;
          return result;
        }
        result[key] = false;
        return result;
      }, {});
      const selectedInspectionDocData = this.inspectionDocs && this.inspectionDocs.reduce((result, ins) => {
        const key = ins.name;
        if (selectedInspectionDoc.indexOf(key) !== -1) {
          result[key] = true;
          return result;
        }
        result[key] = false;
        return result;
      }, {});
      return { selectedInspectionData, selectedInspectionDocData };
    },
    isReasonValidLength() {
      return !!(this.overrideReason.data === 'Others' && this.overrideReason.custom.length < 15);
    },
    isDedicatedIndent() {
      return this.currentOrder.destinations &&
        this.currentOrder.destinations.some(dest => dest.contract && dest.contract.is_dedicated === true);
    },
    isDedicatedVehicleNumberFeatureEnabled() {
      return this.$hasFeature('dedicated_vehicle_number');
    },
    isSarathiOverrideEnabled() {
      return this.$hasPermission('override_vahan_sarathi_validation_transporter');
    },
    integrationMessage() {
      const hasVahanErrors = (this.vahanInvalidFields || []).length > 0;
      const hasSarathiErrors = (this.sarathiInvalidFields || []).length > 0;
      const sarathiValidationEnabled = this.isSarathiValidationEnabled;
      const vahanValidationEnabled = this.isVahanValidationEnabled;

      const vahanFailed = hasVahanErrors || this.status.includes(vahanSarathi.VAHAN_FAILED);
      const sarathiFailed = hasSarathiErrors || this.status.includes(vahanSarathi.SARATHI_FAILED);
      const bothFailed = vahanFailed && sarathiFailed || this.status.includes(vahanSarathi.BOTH_FAILED);

      let message = '';
      if (bothFailed) {
        message = 'VAHAN_SARATHI_INTEGRATION_INVALID_DETAILS';
      } else if (vahanFailed) {
        message = 'VAHAN_INTEGRATION_INVALID_DETAILS';
      } else if (sarathiFailed) {
        message = 'SARATHI_INTEGRATION_INVALID_DETAILS';
      } else if (sarathiValidationEnabled && vahanValidationEnabled) {
        message = 'VAHAN_SARATHI_INTEGRATION_INVALID_DETAILS';
      } else if (sarathiValidationEnabled) {
        message = 'SARATHI_INTEGRATION_INVALID_DETAILS';
      } else {
        message = 'VAHAN_INTEGRATION_INVALID_DETAILS';
      }
      return message;
    },
    dynamicVerificationTitle() {
      const isSarathiEnabled = this.isSarathiValidationEnabled;
      const isVahanEnabled = this.isVahanValidationEnabled;

      let title = '';
      if (isSarathiEnabled && isVahanEnabled) {
        title = 'VAHAN_SARATHI_VERFICATION';
      } else if (isSarathiEnabled) {
        title = 'SARATHI_VERIFICATION';
      } else {
        title = 'VAHAN_VERIFICATION';
      }
      return title;
    },
    computedVolume(){
      // If dimensions were edited, calculate from L×W×H
      if (this.dimensionsEdited) {
        const length = this.vehicleLength || 0;
        const width = this.vehicleWidth || 0;
        const height = this.vehicleHeight || 0;

        const preferredUnit = this.preferredVolumeUnit;

        if (preferredUnit === VolumeUnits.CCM) {
          const lengthCm = convert(length).from(this.vehicleDimensionsUOM).to(vehicleDimensionUnits.CM);
          const widthCm = convert(width).from(this.vehicleDimensionsUOM).to(vehicleDimensionUnits.CM);
          const heightCm = convert(height).from(this.vehicleDimensionsUOM).to(vehicleDimensionUnits.CM);
          return (lengthCm * widthCm * heightCm).toFixed(2);
        } else if (preferredUnit === VolumeUnits.CBM) {
          const lengthM = convert(length).from(this.vehicleDimensionsUOM).to('m');
          const widthM = convert(width).from(this.vehicleDimensionsUOM).to('m');
          const heightM = convert(height).from(this.vehicleDimensionsUOM).to('m');
          return (lengthM * widthM * heightM).toFixed(2);
        }

        const lengthFt = convert(length).from(this.vehicleDimensionsUOM).to(vehicleDimensionUnits.FT);
        const widthFt = convert(width).from(this.vehicleDimensionsUOM).to(vehicleDimensionUnits.FT);
        const heightFt = convert(height).from(this.vehicleDimensionsUOM).to(vehicleDimensionUnits.FT);
        return (lengthFt * widthFt * heightFt).toFixed(2);
      }

      // If dimensions not edited, use DB volume
      if (this.vehicleVolume && this.vehicleVolume > 0) {
        return this.vehicleVolume;
      }

      return 0;
    },
    hasValidOverrideReason() {
      if (this.overrideReason.data === this.$t('OTHERS')) {
        return this.overrideReason.custom && this.overrideReason.custom.length >= 15;
      }
      return this.overrideReason.data && this.overrideReason.data.length > 0;
    },
  },
  methods: {
    async addRcAttachment(file) {
      try {
        const formData = new FormData();
        formData.append('attachment', file.raw);
        const result = await this.$store.dispatch('order/addAttachment', formData);
        if (result && result.id) {
          this.rcAttachmentsList.push({
            id: result.id,
            name: result.name || file.name,
            url: result.attachment_url || '',
          });
        } else {
          this.$errorMessage({ message: 'Upload failed' });
        }
      } catch (err) {
        const msg = err && err.data && err.data.errors && err.data.errors[0] && err.data.errors[0].message;
        this.$errorMessage({ message: msg || 'Upload failed' });
      }
    },
    removeRcAttachment(file) {
      this.rcAttachmentsList = this.rcAttachmentsList.filter(a => a.id !== file.id);
    },
    getVehicleDimensionsLabel(type) {
      return this.$t(`MDM_${type.toUpperCase()}_IN_${this.vehicleDimensionsUOM.toUpperCase()}`);
    },
    setVehicleValues() {
      const vehicleNumberDetails = this.vehicleNumberDropdownValues.find(
        val => val.id === this.vehicleNumberId);
      if (vehicleNumberDetails) {
        this.vehicleNumberValue = vehicleNumberDetails.number;
        const parts = (vehicleNumberDetails.number || '').trim().split(' ');
        if (parts.length > 2) {
          this.type1State = parts[0];
          this.type1District = parts[1];
          this.type1primNumber = parts[2];
          this.type1secNumber = parts[3];
          this.vehicleNumberType = 'type1';
          this.type2PrimNumber = null;
          this.type2SecNumber = null;
        } else {
          this.type2PrimNumber = parts[0];
          this.type2SecNumber = parts[1];
          this.vehicleNumberType = 'type2';
          this.type1State = null;
          this.type1District = null;
          this.type1primNumber = null;
          this.type1secNumber = null;
        }
        this.fitnessDate = vehicleNumberDetails.fitness_validity;
        this.insuranceDate = vehicleNumberDetails.insurance_validity;
        this.bharatStage = vehicleNumberDetails.bharat_stage;
        this.chasisNumber = vehicleNumberDetails.chasis_number;
        this.remarks = vehicleNumberDetails.remarks;
        this.engineNumber = vehicleNumberDetails.engine_number;
        this.estimateArrivalTime = vehicleNumberDetails.estimate_arrival_time;
        this.rcNumber = vehicleNumberDetails.rc_number;
        this.existingRc = vehicleNumberDetails.rc_number || '';
        this.tareUnladenWeight = vehicleNumberDetails.tare_unladen_weight;
        this.grossVehicleWeight = vehicleNumberDetails.gross_vehicle_weight;
        this.existingTareWeight = vehicleNumberDetails.tare_unladen_weight || '';
        this.existingGrossWeight = vehicleNumberDetails.gross_vehicle_weight || '';
        this.rcAttachmentsList = (vehicleNumberDetails.rc_attachments || []).map(doc => ({
          id: doc.id, name: doc.name, url: doc.url,
        }));
      }
    },
    setDriverValues() {
      const phoneNumberDetails = this.phoneNumberDropdownValues.find(
        val => val.driver_id === this.driverNumberId);
      if (phoneNumberDetails) {
        this.driverPhNumber = phoneNumberDetails.mobile_number;
        this.driverName = phoneNumberDetails.driver_name;
        this.driverLicense = phoneNumberDetails.license_number;
      }
    },
    setType(type) {
      this.vehicleNumberType = type;
      this.populateDimensions();
    },
    populateDimensions: debounce(async function search(data = null) {
      let vehicleNumber = data;
      let invalid = !vehicleNumber;
      const vehicleType = this.vehicleNumberType;
      if (!vehicleNumber && !this.hasOverrideTypeWithVehicleConfig) {
        if (vehicleType === 'type1') {
          invalid = this.$v.type1.$invalid;
        } else if (vehicleType === 'type0') {
          invalid = this.$v.type0.$invalid;
        } else {
          invalid = this.$v.type2.$invalid;
        }
      }
      if (!invalid) {
        if (!this.hasOverrideTypeWithVehicleConfig) {
          if (vehicleType === 'type1') {
            const state = this.type1State;
            const district = this.type1District;
            const primNumber = this.type1primNumber;
            const secNumber = this.type1secNumber;
            vehicleNumber = `${state} ${district} ${primNumber} ${secNumber}`;
          }
          if (vehicleType === 'type2') {
            const primNum = this.type2PrimNumber;
            const secNum = this.type2SecNumber;
            vehicleNumber = `${primNum} ${secNum}`;
          }
          if (vehicleType === 'type0') {
            vehicleNumber = this.type0Number;
          }
        }
        const obj = { number: vehicleNumber, is_vehicle_available: true };
        const vehicleDetails = await this.$store.dispatch('indents/getVehicleNumberList', { data: obj });
        if (vehicleDetails.data.length) {
          this.vehicleHeight = vehicleDetails.data[0].vehicle_height || 0;
          this.vehicleWidth = vehicleDetails.data[0].vehicle_width || 0;
          this.vehicleLength = vehicleDetails.data[0].vehicle_length || 0;
          this.vehicleVolume = vehicleDetails.data[0].vehicle_volume || 0;
          this.dimensionsEdited = false;
          this.vehicleWeightCapacity = vehicleDetails.data[0].vehicle_weight_capacity || 0;
          this.rcNumber = vehicleDetails.data[0].rc_number || '';
          this.existingRc = vehicleDetails.data[0].rc_number || '';
          this.tareUnladenWeight = vehicleDetails.data[0].tare_unladen_weight || '';
          this.grossVehicleWeight = vehicleDetails.data[0].gross_vehicle_weight || '';
          this.existingTareWeight = vehicleDetails.data[0].tare_unladen_weight || '';
          this.existingGrossWeight = vehicleDetails.data[0].gross_vehicle_weight || '';
          this.rcAttachmentsList = (vehicleDetails.data[0].rc_attachments || []).map(doc => ({ id: doc.id, name: doc.name, url: doc.url }));
        } else {
          this.vehicleHeight = 0;
          this.vehicleWidth = 0;
          this.vehicleLength = 0;
          this.vehicleVolume = 0;
          this.dimensionsEdited = false;
          this.vehicleWeightCapacity = 0;
          this.rcNumber = '';
          this.existingRc = '';
          this.tareUnladenWeight = '';
          this.grossVehicleWeight = '';
          this.existingTareWeight = '';
          this.existingGrossWeight = '';
          this.rcAttachmentsList = [];
        }
      }
    }),
    shouldRestrictDuplicateVehicle() {
      if (!this.$hasFeature('restrict_duplicate_vehicle_assign')) return false;

      // Vehicle-type-level check (takes final precedence)
      if (this.$hasFeature('allow_vehicle_reuse_vehicle_type')) {
        return !this.currentOrder.vehicle_type_data?.allow_vehicle_reuse;
      }

      // Transporter-level check
      if (this.$hasFeature('allow_vehicle_reuse_transporter')) {
        return !this.currentOrder.transporter?.allow_vehicle_reuse;
      }

      return true;
    },
    async isDetailsExist() {
      const vehicleType = this.vehicleNumberType;
      const getVehicleNumber = this.vehicleNumber(vehicleType);
      this.vehicleNo = getVehicleNumber;
      if (this.$hasFeature('restrict_vehicle_assignment_for_type') &&
        !this.hasOverrideTypeWithVehicleConfig) {
        const obj = { number: this.vehicleNo };
        const vehicleDetails = await this.$store.dispatch('indents/getVehicleNumberList', { data: obj });
        if (vehicleDetails.data.length) {
          const indentVehicleTypeId = this.currentOrder.vehicle_type_data &&
            this.currentOrder.vehicle_type_data._id.toString();
          const vehicleTypeId = vehicleDetails.data[0] && vehicleDetails.data[0].type;
          if (indentVehicleTypeId !== vehicleTypeId) {
            this.$errorMessage({ message:
            `Vehicle type of vehicle number entered doesn't match with the vehicle detail master.
            Please contact your ${this.currentClient.name} SPOC ` });
            return;
          }
        }
      }
      const indentResult = await this.$store.dispatch('indents/isDuplicateVehicleAssignment',
        { vehicleNumber: getVehicleNumber, orderNo: this.currentOrder.order_no });
      if (indentResult && this.shouldRestrictDuplicateVehicle()) {
        this.indentNo = indentResult.order_no;
        this.showDuplicateVehicleFlag = true;
      } else {
        const result = await this.$store.dispatch('indents/isDetailsExist', {
          vehicleNumber: getVehicleNumber,
          orderNo: this.currentOrder.order_no,
        });
        if (result) {
          this.indentNo = (this.currentClient.id === result.client_id) ?
            result.order_no : 'NA';
          this.showAlertFlag = true;
        } else {
          await this.activeTripCheck();
        }
      }
    },

    async searchVehicleByNumber() {
      const vehicleType = this.vehicleNumberType;
      const vehicleNumber = this.vehicleNumber(vehicleType);
      let invalid = !vehicleNumber;
      if (!invalid) {
        const obj = { number: vehicleNumber };
        const vehicleDetails = await this.$store.dispatch('indents/getVehicleNumberList', { data: obj });
        if (vehicleDetails.data.length) {
          this.bharatStage = vehicleDetails.data[0].bharat_stage || '';
          this.rcNumber = vehicleDetails.data[0].rc_number || '';
          this.existingRc = vehicleDetails.data[0].rc_number || '';
          this.tareUnladenWeight = vehicleDetails.data[0].tare_unladen_weight || '';
          this.grossVehicleWeight = vehicleDetails.data[0].gross_vehicle_weight || '';
          this.existingTareWeight = vehicleDetails.data[0].tare_unladen_weight || '';
          this.existingGrossWeight = vehicleDetails.data[0].gross_vehicle_weight || '';
          this.rcAttachmentsList = (vehicleDetails.data[0].rc_attachments || []).map(doc => ({ id: doc.id, name: doc.name, url: doc.url }));
        } else {
          this.bharatStage = '';
          this.rcNumber = '';
          this.existingRc = '';
          this.tareUnladenWeight = '';
          this.grossVehicleWeight = '';
          this.existingTareWeight = '';
          this.existingGrossWeight = '';
          this.rcAttachmentsList = [];
        }
      }
    },
    async activeTripCheck() {
      this.showAlertFlag = false;
      const vehicleType = this.vehicleNumberType;
      const getVehicleNumber = this.vehicleNumber(vehicleType);
      const result = await this.$store.dispatch('indents/activeTrip', {
        vehicleNumber: getVehicleNumber,
        phoneNumber: this.driverPhNumber,
        isActiveTrip: this.isActiveTrip,
        orderNo: this.currentOrder.order_no,
      });
      if (result) {
        this.indentNo = this.currentClient.id === result.tenantId ? result.shipmentNumber : 'NA';
        this.showDialogFlag = true;
      } else {
        await this.assign();
      }
    },
    getEDD(destinations, sources) {
      const latestExpectedDelivery = destinations.reduce((latest, item) => {
        const currentDate = new Date(item.expected_delivery_at);
        return currentDate > latest ? currentDate : latest;
      }, new Date(0));

      if (latestExpectedDelivery.getTime() === new Date(0).getTime()) {
        const latestLoadingDate = sources.reduce((latest, item) => {
          const currentDate = new Date(item.vehicle_req_date);
          return currentDate > latest ? currentDate : latest;
        }, new Date(0));

        return latestLoadingDate;
      }

      return latestExpectedDelivery;
    },
    async vahanSarathiValidation() {
      const edd = this.getEDD(this.currentOrder.destinations, this.currentOrder.sources);
      this.data.edd = edd;
      this.data.driver = {};
      this.data.vehicle = {};
      const vehicleType = this.vehicleNumberType;
      if (this.hasNonIndiaTimeZone) {
        this.$v.type0.$touch();
      }
      const vehicleNumber = this.vehicleNumber(vehicleType);
      if (vehicleNumber) {
        this.data.vehicle.number = vehicleNumber;
      }
      if (this.isVahanValidationEnabled || this.isSarathiValidationEnabled) {
        if (!this.hasOverrideTypeWithVehicleConfig
          || (this.hasOverrideTypeWithVehicleConfig && this.isDedicatedVehicleNumberFeatureEnabled && !this.isDedicatedIndent)
        ) {
          if (vehicleType === 'type1') {
            this.$v.type1.$touch();
          } else {
            this.$v.type2.$touch();
          }
          if ((this.vehicleNumberType === 'type1' && this.$v.type1.$dirty && this.$v.type1.$error) ||
          (this.vehicleNumberType === 'type2' && this.$v.type2.$dirty && this.$v.type2.$error) ||
          (this.vehicleNumberType === 'type0' && this.$v.type0.$dirty && this.$v.type0.$error)) {
            this.$errorMessage({ message: this.$getErr('INVALID_VEHICLE_NUMBER') });
            return;
          }
          this.$v.driverPhNumber.$touch();
          if (this.$v.driverPhNumber.$dirty && this.$v.driverPhNumber.$error) {
            this.$errorMessage({ message: this.$getErr('INVALID_MOBILE_NUMBER') });
            return;
          }
          this.$v.estimateArrivalTime.$touch();
          if (this.$v.estimateArrivalTime.$dirty && this.$v.estimateArrivalTime.$error) {
            this.$errorMessage({ message: this.$getErr('INVALID_ESTIMATED_ARRIVAL_DATE_TIME') });
            return;
          }
        }
      }

      if (this.isSarathiValidationEnabled && !this.driverLicense) {
        this.$errorMessage({ message: this.$getErr('NEED_LICENSE_FOR_DRIVER_VALIDATION') });
        return;
      }
      if (this.isSarathiValidationEnabled && !this.driverDOB) {
        this.$errorMessage({ message: this.$getErr('NEED_DOB_FOR_DRIVER_VALIDATION') });
        return;
      }
      if (this.driverLicense) {
        this.data.driver.license_number = this.driverLicense;
      }

      if (this.driverDOB) {
        this.data.driver.driver_dob = this.driverDOB;
      }
      if (vehicleNumber) {
        this.data.vehicle.number = vehicleNumber;
      }
      if (this.vehicleNumberId) {
        this.data.vehicle.id = this.vehicleNumberId;
      }
      // Vehicle
      if (this.vehicleMake) {
        this.data.vehicle.vehicle_make = this.vehicleMake;
      }
      if (this.chasisNumber) {
        this.data.vehicle.chasis_number = this.chasisNumber;
      }
      if (this.remarks) {
        this.data.remarks = this.remarks;
      }
      if (this.engineNumber) {
        this.data.vehicle.engine_number = this.engineNumber;
      }
      if (this.fitnessDate) {
        this.data.vehicle.fitness_validity = this.fitnessDate;
      }
      if (this.insuranceDate) {
        this.data.vehicle.insurance_validity = this.insuranceDate;
      }
      if (this.estimateArrivalTime) {
        this.data.vehicle.estimate_arrival_time = this.estimateArrivalTime;
      }
      if(this.bharatStage) {
        this.data.vehicle.bharat_stage = this.bharatStage;
      }
      if (this.rcAttachmentsList.length) {
        this.data.vehicle.rc_attachment_ids = this.rcAttachmentsList.map(a => a.id);
      }
      // Driver
      if (this.driverName) {
        this.data.driver.name = this.driverName;
      }
      if (this.driverLicense) {
        this.data.driver.license_number = this.driverLicense;
      }
      if (this.driverPhNumber) {
        this.data.driver.phone_number = this.driverPhNumber;
      }
      if (this.isVahanSarathiEnabled) {
        this.data.order_numbers = [this.currentOrder.order_no];
        try {
          const response = await this.$store.dispatch('order/driverValidation', { data: this.data });
          if (response && response.error) {
            throw new Error(response.error);
          }
          this.transactionId = response.transactionId;

          this.statusValidation();
        } catch (error) {
          this.$errorMessage({ message: error.message || error });
          return;
        }
      }
    },
    handleCancelOverride() {
      this.showValidationFlag = false;
      this.showOverride = false;
    },
    vehicleNumber(vehicleType) {
      let vehicleNumber = this.vehicleNumberValue;
      if (vehicleType === 'type0') {
        vehicleNumber = this.type0Number;
      }
      if (!this.hasOverrideTypeWithVehicleConfig
        || (this.hasOverrideTypeWithVehicleConfig && this.isDedicatedVehicleNumberFeatureEnabled && !this.isDedicatedIndent)
      ) {
        if (vehicleType === 'type1') {
          const state = this.type1State;
          const district = this.type1District;
          const primNumber = this.type1primNumber;
          const secNumber = this.type1secNumber;
          vehicleNumber = `${state} ${district} ${primNumber} ${secNumber}`;
        }
        if (vehicleType === 'type2') {
          const primNum = this.type2PrimNumber;
          const secNum = this.type2SecNumber;
          vehicleNumber = `${primNum} ${secNum}`;
        }
      }
      return vehicleNumber;
    },
    async getOverrideReasons() {
      if (this.skipValidation) {
        this.isVahanSarathiValidated = true;
        this.showOverride = true;
        return;
      }
      let depotId;
      const order = this.currentOrder;

      if (order && [1, 2].includes(order.movement)) {
        depotId = order.sources && order.sources[0]
          && order.sources[0].location_id;
      } else {
        depotId = order.destinations && order.destinations[0]
          && order.destinations[0].location_id;
      }
      const payload = {
        type: 'OVERRIDE_VAHAN_SARATHI',
        movement: order && order.movement,
        depot_id: depotId,
      };
      const result = await this.$store.dispatch('indents/getReasonSettings', payload);
      if (result && result.data && result.data.length) {
        const configReasons = result.data.map(item => ({
          key: item,
          value: item,
        }));
        this.overrideReasonList = [
          ...overrideReasonOptions,
          ...configReasons,
          {
            value: 'Others',
            key: 'OTHERS',
          },
        ];
      } else {
        this.overrideReasonList = [
          ...overrideReasonOptions,
          {
            value: 'Others',
            key: 'OTHERS',
          },
        ];
      }

      this.showOverride = true;
    },
    async submitOverrideReason() {
      if(!this.hasValidOverrideReason) {
        return;
      }
      this.handleCancelOverride();
      this.isVahanSarathiValidated = true;
    },
    async assign() {
      const vehicleType = this.vehicleNumberType;
      if (vehicleType === 'type0') {
        this.$v.type0.$touch();
      }
      if (!this.hasOverrideTypeWithVehicleConfig
        || (this.hasOverrideTypeWithVehicleConfig && this.isDedicatedVehicleNumberFeatureEnabled && !this.isDedicatedIndent)
      ) {
        if (vehicleType === 'type1') {
          this.$v.type1.$touch();
        } else {
          this.$v.type2.$touch();
        }
        if ((this.vehicleNumberType === 'type1' && this.$v.type1.$dirty && this.$v.type1.$error) ||
        (this.vehicleNumberType === 'type2' && this.$v.type2.$dirty && this.$v.type2.$error) ||
        (this.vehicleNumberType === 'type0' && this.$v.type0.$dirty && this.$v.type0.$error)) {
          this.$errorMessage({ message: this.$getErr('INVALID_VEHICLE_NUMBER') });
          return;
        }
        this.$v.driverPhNumber.$touch();
        if (this.$v.driverPhNumber.$dirty && this.$v.driverPhNumber.$error) {
          this.$errorMessage({ message: this.$getErr('INVALID_MOBILE_NUMBER') });
          return;
        }
        this.$v.estimateArrivalTime.$touch();
        if (this.$v.estimateArrivalTime.$dirty && this.$v.estimateArrivalTime.$error) {
          this.$errorMessage({ message: this.$getErr('INVALID_ESTIMATED_ARRIVAL_DATE_TIME') });
          return;
        }
      }

      if (this.isRCMandatory) {
        this.$v.rcNumber.$touch();
        if (this.$v.rcNumber.$dirty && this.$v.rcNumber.$error) {
          this.$errorMessage({ message: this.$getErr('RC_NUMBER_REQUIRED') });
          return;
        }
        this.$v.tareUnladenWeight.$touch();
        if (this.$v.tareUnladenWeight.$dirty && this.$v.tareUnladenWeight.$error) {
          this.$errorMessage({ message: this.$getErr('TARE_UNLADEN_WEIGHT_REQUIRED') });
          return;
        }
        this.$v.grossVehicleWeight.$touch();
        if (this.$v.grossVehicleWeight.$dirty && this.$v.grossVehicleWeight.$error) {
          this.$errorMessage({ message: this.$getErr('GROSS_VEHICLE_WEIGHT_REQUIRED') });
          return;
        }
      }
      if (this.isRCAttachmentMandatory && !this.rcAttachmentsList.length) {
        this.$errorMessage({ message: this.$getErr('RC_ATTACHMENT_UPLOAD_REQUIRED') });
        return;
      }
      const vehicleNumber = this.vehicleNumber(vehicleType);
      const data = {
        vehicle: {},
        driver: {},
      };
      if (vehicleNumber) {
        data.vehicle.number = vehicleNumber;
      }
      if (this.vehicleNumberId) {
        data.vehicle.id = this.vehicleNumberId;
      }
      // Vehicle
      if (this.vehicleMake) {
        data.vehicle.vehicle_make = this.vehicleMake;
      }
      if (this.chasisNumber) {
        data.vehicle.chasis_number = this.chasisNumber;
      }
      if (this.remarks) {
        data.remarks = this.remarks;
      }
      if (this.engineNumber) {
        data.vehicle.engine_number = this.engineNumber;
      }
      if (this.fitnessDate) {
        data.vehicle.fitness_validity = this.fitnessDate;
      }
      if (this.insuranceDate) {
        data.vehicle.insurance_validity = this.insuranceDate;
      }
      if (this.estimateArrivalTime) {
        data.vehicle.estimate_arrival_time = this.estimateArrivalTime;
      }
      if(this.$hasFeature('vehicle_dimensions_mandatory_for_new_truck') || this.$hasFeature('decouple_feature_for_vehicle_dimensions')){
        if (this.vehicleLength) {
          data.vehicle.vehicle_length = this.vehicleLength;
        }
        if (this.vehicleHeight) {
          data.vehicle.vehicle_height = this.vehicleHeight;
        }
        if (this.vehicleWidth) {
          data.vehicle.vehicle_width = this.vehicleWidth;
        }
      }
      if(this.$hasFeature('vehicle_dimensions_mandatory_for_new_truck') && this.vehicleWeightCapacity){
          data.vehicle.vehicle_weight_capacity = this.vehicleWeightCapacity;
      }
      if(this.bharatStage) {
        data.vehicle.bharat_stage = this.bharatStage;
      }
      if (this.rcNumber) {
        data.vehicle.rc_number = this.rcNumber || '';
      }
      if (this.rcAttachmentsList.length) {
        data.vehicle.rc_attachment_ids = this.rcAttachmentsList.map(a => a.id);
      }
      if (this.tareUnladenWeight) {
        data.vehicle.tare_unladen_weight = this.tareUnladenWeight;
      }
      if (this.grossVehicleWeight) {
        data.vehicle.gross_vehicle_weight = this.grossVehicleWeight;
      }

      // Driver
      if (this.driverNumberId) {
        data.driver.id = this.driverNumberId;
      }
      if (this.driverName) {
        data.driver.name = this.driverName;
      }
      if (this.driverLicense) {
        data.driver.license_number = this.driverLicense;
      }
      if (this.driverPhNumber) {
        data.driver.phone_number = this.driverPhNumber;
      }
      if(this.driverDOB){
       data.driver.dob = this.driverDOB;
      }

      if (this.isIndented) {
        data.assignTruck = true;
      }
      if (this.isSarathiOverrideEnabled) {
        data.reason = this.overrideReason.data === 'Others' ? this.overrideReason.custom : this.overrideReason.data;
        data.validation_error = this.$t(`${this.integrationMessage}`);
      }
      let inspectionData = null;
      if (this.isVahanValidationEnabled && this.localValidFields.length) {
        const newSelectedDocs = this.inspectionDocs
          .filter(doc => this.localValidFields.includes(doc.name))
          .map(doc => doc.name);

        this.selectedInspectionDoc = newSelectedDocs;
        inspectionData = {
          accepted: true,
          inspection: this.getInspectionData.selectedInspectionData,
          documents: this.getInspectionData.selectedInspectionDocData,
        };
      }
      if(!this.isProgress){
        this.isProgress = true;
        this.$emit('updateTruck', data, inspectionData);

        setTimeout(()=>{
          this.isProgress = false;
        },10000)
      }
    },
    queryfire(val) {
      if (val.length >= 3) {
        this.$emit('query-driver', val);
      } else if (val.length === 0) {
        this.$emit('query-driver');
      }
    },
    async statusValidation() {
      this.showValidationFlags = true;
      this.invalidFieldsList = [];
      this.steps = [];


      this.pollVerificationStatus();

      this.intervalId = setInterval(() => {
        this.pollVerificationStatus();
      }, 1500);
    },

    async pollVerificationStatus() {
      try {
        const response = await this.$store.dispatch('order/getVerification', {
          transactionId: this.transactionId,
          orderNo: this.currentOrder.order_no,
        });

        this.updateStepStatuses(response);

        if (this.steps.every(step => step.status === 'completed')) {
          clearInterval(this.intervalId);
          setTimeout(() => {
            this.showValidationFlags = false;
          }, 3000);
        }
        if (this.steps.some(step => step.status === 'failed')) {
          clearInterval(this.intervalId);
          setTimeout(() => {
            this.showValidationFlags = false;
          }, 3000);
        }
      } catch (error) {
        clearInterval(this.intervalId);
        this.showValidationFlags = false;
      }
    },
    async updateStepStatuses(response) {
      const { status, vahanInvalidFields = [], sarathiInvalidFields = [], message, validFields = [] } = response;
      this.invalidFieldsList = [];
      this.localValidFields = validFields;
      this.vahanInvalidFields = vahanInvalidFields;
      this.sarathiInvalidFields = sarathiInvalidFields;
      const invalidFields = [...vahanInvalidFields, ...sarathiInvalidFields];
      this.status = status;

      if (Array.isArray(invalidFields) && invalidFields.length > 0) {
        this.invalidFieldsList = invalidFields.map((field, index) => `${field.split('\'').join(' ')}`);
      }

      if (status.includes(vahanSarathi.VAHAN_PROCESSING)) {
        this.steps = [
          { id: 'vahan-processing', name: vahanSarathi.VAHAN_VERIFICATION, status: this.mapStatus(status) },
        ];
      } else if (status.includes(vahanSarathi.VAHAN_COMPLETED)) {
        this.steps = [
          { id: 'vahan-completed', name: vahanSarathi.VAHAN_VERIFICATION, status: this.mapStatus(status) },
        ];
      } else if (status.includes(vahanSarathi.VAHAN_FAILED)) {
        this.steps = [
          { id: 'vahan-failed', name: vahanSarathi.VAHAN_VERIFICATION, status: this.mapStatus(status) },
        ];
      } else if (status.includes(vahanSarathi.SARATHI_PROCESSING)) {
        this.steps = [
          { id: 'sarathi-processing', name: vahanSarathi.SARATHI_VERIFICATION, status: this.mapStatus(status) },
        ];
      } else if (status.includes(vahanSarathi.SARATHI_COMPLETED)) {
        this.steps = [
          { id: 'sarathi-completed', name: vahanSarathi.SARATHI_VERIFICATION, status: this.mapStatus(status) },
        ];
      } else if (status.includes(vahanSarathi.SARATHI_FAILED)) {
        this.steps = [
          { id: 'sarathi-failed', name: vahanSarathi.SARATHI_VERIFICATION, status: this.mapStatus(status) },
        ];
      } else if (status.includes(vahanSarathi.BOTH_PROCESSING)) {
        this.steps = [
          { id: 'both-processing', name: vahanSarathi.VAHAN_SARATHI_VERIFICATION, status: this.mapStatus(status) },
        ];
      } else if (status.includes(vahanSarathi.BOTH_COMPLETED)) {
        this.steps = [
          { id: 'both-completed', name: vahanSarathi.VAHAN_SARATHI_VERIFICATION, status: this.mapStatus(status) },
        ];
      } else if (status.includes(vahanSarathi.BOTH_FAILED)) {
        this.steps = [
          { id: 'both-failed', name: vahanSarathi.VAHAN_SARATHI_VERIFICATION, status: this.mapStatus(status) },
        ];
      } else if (status.includes(vahanSarathi.NO_VALIDATION_VAHAN)) {
        this.steps = [
          { id: 'no-vahan-validation', name: vahanSarathi.VAHAN_VERIFICATION, status: this.mapStatus(status) },
        ];
      } else if (status.includes(vahanSarathi.NO_VALIDATION_SARATHI)) {
        this.steps = [
          { id: 'no-sarathi-validation', name: vahanSarathi.SARATHI_VERIFICATION, status: this.mapStatus(status) },
        ];
      }

      if (status === vahanSarathi.VAHAN_COMPLETED || status === vahanSarathi.SARATHI_COMPLETED || status === vahanSarathi.STATUS_BOTH_COMPLETED) {
        this.invalidFieldsList = invalidFields;
      } else if (status === vahanSarathi.VAHAN_FAILED || status === vahanSarathi.SARATHI_FAILED) {
        this.invalidFieldsList = [message];
      }

      if (status === vahanSarathi.NO_VALIDATION_SARATHI || status === vahanSarathi.NO_VALIDATION_VAHAN) {
        this.invalidFieldsList = [message];
        this.skipValidation = true;
      }

      if (status.includes(vahanSarathi.STATUS_PROCESSING)) {
        this.showValidationFlag = false;
        return;
      }
      if (this.invalidFieldsList.length === 0 && !message) {
        this.showValidationFlag = false;
        this.isVahanSarathiValidated = true;
      } else {
        setTimeout(() => {
          this.showValidationFlag = true;
        }, 2000);
      }
    },
    mapStatus(status) {
      let mappedStatus = 'pending';
      if (status.includes(vahanSarathi.STATUS_PROCESSING)) {
        mappedStatus = 'processing';
      } else if (status.includes(vahanSarathi.STATUS_COMPLETED)) {
        mappedStatus = 'completed';
      } else if (status.includes(vahanSarathi.STATUS_FAILED)) {
        mappedStatus = 'failed';
      } else if (
        status.includes(vahanSarathi.NO_VALIDATION_VAHAN) ||
        status.includes(vahanSarathi.NO_VALIDATION_SARATHI)
      ) {
        mappedStatus = 'failed';
      }
      return mappedStatus;
    },
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
};
</script>
<style>
.dialog-header {
  text-align: center;
  margin-bottom: 30px;
}

.dialog-title {
  font-size: 1.5rem;
  color: #005399;
  margin: 0;
}

.status-section {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  padding: 1rem;
}

.status-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.3rem;
  color: #555555;
  animation: fadeIn 1s ease-in-out;
}

.status-box .spinner {
  margin-right: 3px;
  border: 4px solid #cccccc;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;
}

.status-red {
  background-color: #ffcccc;
  color:black;
  border-radius: 5px;
  padding: 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

</style>
<style scoped>
.is-disabled {
  pointer-events: none !important;
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}
</style>
